import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { choose_text, choose_button } from "../texts/login";
import UserDetails from "../upload_file/user_details";
import { saveUser } from "../context/userReducer";
import "./choosePartnership.css"

const ChoosePartnership = () => {
    const partnerships = useSelector((state) => state.partnerships);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleChoose = (partner) => {
        dispatch(saveUser(partner));
        navigate("/fill");
    };

    return (
        <div className="choose-container">
            <div className="alert alert-success choose-alert" role="alert">
                {choose_text}
            </div>
            <div className="choose-list">
                {partnerships.map((partner, index) => (
                    <div key={index} className="choose-card">
                        <UserDetails user={partner} showButton={false} />
                        <button className="btn btn-primary choose-btn" onClick={() => handleChoose(partner)}>
                            {choose_button}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ChoosePartnership;
